import React from 'react';
import { Image, Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';

const colors = [1, 2, 3, 4];

const CarouselWithClickableCardsSlide = ({ data, index }) => {
  let hoverEffect = false;
  if (data?.fields?.link?.value?.href) {
    hoverEffect = true;
  }
  return hoverEffect ? (
    <Link
      field={data.fields.link}
      className={clsx('carousel-clickable-slide', `cc-slide-${colors[index] || colors[index - 4]}`)}
    >
      <div className="cc-slide-icon-wrapper">
        <Image
          field={data.fields.image}
          className={clsx('cc-slide-icon', 'icon-main', !hoverEffect && 'no-effect')}
        />
        <Image
          field={data.fields.hoveredImage}
          className={clsx('cc-slide-icon', 'icon-secondary', !hoverEffect && 'no-effect')}
        />
      </div>
      <div className="cc-slide-heading">
        <Text field={data.fields.heading} />
      </div>
      <RichText className="cc-slide-text" field={data.fields.text} />
    </Link>
  ) : (
    <div
      className={clsx('carousel-clickable-slide', `cc-slide-${colors[index] || colors[index - 4]}`)}
    >
      <div className="cc-slide-icon-wrapper">
        <Image
          field={data.fields.image}
          className={clsx('cc-slide-icon', 'icon-main', !hoverEffect && 'no-effect')}
        />
        <Image
          field={data.fields.hoveredImage}
          className={clsx('cc-slide-icon', 'icon-secondary', !hoverEffect && 'no-effect')}
        />
      </div>
      <div className="cc-slide-heading">
        <Text field={data.fields.heading} />
      </div>
      <RichText className="cc-slide-text" field={data.fields.text} />
    </div>
  );
};

export default CarouselWithClickableCardsSlide;
